module.exports = __webpack_public_path__ + "static/media/bg1.5be2c168.jpg";